import { ChildDiscountPricingModel } from "./ChildDiscountPricingModel";

export enum ChildDiscountStatus {
  canAddDiscount = "canAddDiscount",
  AlreadyHasDiscount = "AlreadyHasDiscount",
  HasSomeDiscounts = "HasSomeDiscounts",
}

export interface ChildDiscountModel {
  id: number;
  firstName: string;
  lastName: string;
  israeliId: string;
  address: string;
  nest: string;
  layer: string;
  parents?: string;
  discountEvents: ChildDiscountPricingModel[];
  childStatus: ChildDiscountStatus;
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-models/ChildDiscountModel.ts